<template>
  <span :class="`${tipografia} ${cor}--text text--darken-1 text-no-wrap my-2`">
    {{ texto }}
  </span>
</template>

<script>
export default {
  name: 'AppTitle',

  props: {
    texto: {
      type: String,
      default: '',
    },
    cor: {
      type: String,
      required: false,
      default: 'primary', // https://vuetifyjs.com/en/styles/colors/#material-colors
    },
    tipografia: {
      type: String,
      required: false,
      default: 'title', // https://vuetifyjs.com/en/styles/text-and-typography/#typography
    },
  },
};
</script>
